
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    groupIndex: {
      type: Number,
      required: true
    },
    fields: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: '100px'
    }
  },

  emits: ['set-form-ref', 'update:modelValue'],

  setup(props, context) {
    const { t } = useI18n()

    const setFormRef = (el: any) => {
      context.emit('set-form-ref', props.groupIndex, el)
    }

    const updateField = (prop: string, value: any) => {
      const newModel = { ...props.modelValue, [prop]: value }
      context.emit('update:modelValue', newModel)
    }

    return {
      t,
      setFormRef,
      updateField
    }
  }
})
